module.exports = __webpack_public_path__ + "static/media/JasonMoy@2x.86294a1b.png";